(() => {
  var translateY;
  let para_ele = document.querySelectorAll(".js-parallax");
  para_ele.forEach((ele, index)=> {
    if(ele.classList.contains('js-parallax--reverse')) {
      translateY = '5%';
    } else {
      translateY = '-5%';
    }
    ele.classList.add('js-parallax' + index);
    gsap.to('.js-parallax' + index + ' img', {
      translateY: translateY,
      scrollTrigger: {
        trigger: '.js-parallax' + index, // 要素がビューポートに入ったときにアニメーション開始
        start: 'top bottom',
        scrub: 3,
      }
    });
  });
})();